import { Component } from "react";
import language from "../../../../language";
import { connect } from "react-redux";
import { Table } from "../../../Table";
import { getStorage } from "../../../../utils/storage";
import toastMessage from "../../../../utils/toastMessage";
import icons from "../../../../constants/icons";
import { fetchShippingInQueueData } from "../../../../utils/queries/request/shipping-queue";
import { Modal } from "../../../Modal";
import PrintableLabel from "../../../Production/ComponentLabeling/printableLabel";

class ServedProducts extends Component {
  state = {
    error: {},
    user: {},
    data: [],
    selectedData: {},
    page: 1,
    limit: 50,
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    if (this.props.shipmentNumber) {
      this.getProducts(true);
    }
  };

  getProducts = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const { page, limit } = this.state;

      const { defaultLanguage, shipmentNumber } = this.props;

      const { data, count, totalRecords } = await fetchShippingInQueueData(defaultLanguage, {
        page,
        limit,
        shipmentNumber,
      });

      this.setState({
        isLoading: false,
        data: data,
        totalPageCount: count,
        totalRecords,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
      toastMessage("error", error);
    }
  };

  renderProductHeaders() {
    let headers = [
      // {
      //   title: language[this.props.defaultLanguage].request_number,
      //   key: "requestNo",
      //   styles: {
      //     textTransform: "uppercase",
      //   },

      // },
      {
        title: language[this.props.defaultLanguage].shipment_number,
        key: "shipmentNumber",
        styles: {
          textTransform: "uppercase",
        },
        // type: "link",

        // onPress: (item) => {
        //   this.setState({
        //     selectedData: item,
        //     showLabelModal: true,
        //   });
        // },
      },
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donation.donationNumber",
        type: "link",

        onPress: (item) => {
          this.setState({
            selectedData: item,
            showLabelModal: true,
          });
        },
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "inventory.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].name,
        key: "inventory.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "inventory.bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "updatedAt",
        formatTime: "lll",
        isMoment: true,
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
    ];
    return headers;
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  render() {
    return (
      <div className="card-body">
        <>
          <Table
            isLoading={this.state.isLoading}
            data={this.state.data}
            headers={this.renderProductHeaders()}
            page={this.state.page}
            limit={this.state.limit}
            totalPageCount={this.state.totalPageCount}
            totalRecords={this.state.totalRecords}
            handleAddPressed={() => this.handleOpenModal("showAdd")}
            filters={[
              {
                type: "button",
                title: language[this.props.defaultLanguage].refresh,
                button_type: "button",
                icon: icons.refresh,
                onPress: (item) => this.getProducts(),
              },
            ]}
          />

          <Modal
            handleClose={this.handleCloseModal.bind(this, "showLabelModal")}
            show={this.state.showLabelModal}
            showHeaderBottomBorder={false}
          >
            <PrintableLabel
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showLabelModal",
              )}
              productId={this.state?.selectedData?.inventory?._id}
            />
          </Modal>
        </>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ServedProducts);
